import angular from 'angular';

import TextNotificationComponent from './text-notification.cmpt';

export default angular
    .module('application.component.notifications.component.text-notification', [])
    .component(TextNotificationComponent.selector, TextNotificationComponent);



// WEBPACK FOOTER //
// ./src/application/component/notifications/component/text-notification/index.js